import { Injectable } from '@angular/core';

/**
 * Service to play audio.
 *
 * @export
 */
@Injectable({
    providedIn: 'root',
})
export class AudioService {
    private player: HTMLAudioElement;

    mute: boolean;

    constructor() {
        this.player = new Audio();
    }

    /**
     * Play audio files inside the assets/audio folder.
     */
    play(file: string): void {
        if (this.mute) {
            return;
        }

        this.player.src = `/assets/audio/${file}`;
        this.player.load();
        this.player.play();
    }

    /**
     * Play audio files inside the assets/audio folder.
     */
    playBell(): void {
        this.play('bell.mp3');
    }
}
